module.exports = __webpack_public_path__ + "img/CRT_Sword-003.41c8b9bb.png";